import HttpMethod from '@/consts/httpMethod';
import { processRequest, processSuccessResponse, processErrorResponse } from '@/helpers';

export default {
  async getPromotionDetail(id) {
    const ep = {
      baseURL: process.env.VUE_APP_API_ROOT,
      url: `/v1/promotions/${id}`,
      method: HttpMethod.GET
    };

    try {
      const res = await processRequest(ep);

      const item = processSuccessResponse(res);

      return item;
    } catch(e) {
      processErrorResponse(e.response);
      return false;
    }
  },
};
